import React, { useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit'
import { validateOwnershipTransferStatus } from '../OwnershipTransferSlice'
import { RequestStatus, EquipmentPaymentObligation, OwnershipTransferActionTypeDescription, OwnershipTransferActionType, RequestExecutedByDescription } from '../Constant/Constant'
import { convertDateTimeToDate } from '../../../../utilities/StringHelpers/StringHelpers';
import { dwhDashboardReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const DashboardTableRow = ({ row, validateOwnershipTransferStatus, getEquipmentTitle, data, userDetails, portalsBlock }) => {

  function getColumnData() {

    if (row.statusCodeDescription == RequestStatus.Finished) {
      return <div> הושלם</div>
    }
    else if (row.statusCodeDescription == RequestStatus.Cancelled) { return <div>הבקשה בוטלה</div> }
    else if (row.statusCodeDescription == RequestStatus.Expired) { return <div> לא בתוקף</div> }
    else {

      return <BtnSubmit onclick={() => validateRowStatus()} text={'בדיקת סטטוס'} />
    }
  }

  function validateRowStatus() {

    dwhDashboardReport({
      data: { row: row, userDetails: userDetails, portalsBlock: portalsBlock },
      actionType: DwhActionType.StatusTable,
      messageText: DWHMessageText.StatusTableStatusCheckButtonClicked,
      status: DWHStatus.Ongoing,
    });

    let reqData = {
      RequestId: row.id,
      OrgId: row.orgId,
      SubscriberPhoneNumber: row.subscriberPhoneNumber,
    };

    validateOwnershipTransferStatus(reqData)

  }
  function getEquipmentTitle() {
    if (row.equipmentObligations == EquipmentPaymentObligation.None) {
      return 'לא קיים '
    }
    if (row.actionType == OwnershipTransferActionType.BusinessToPrivate) {
      if (row.equipmentObligations == EquipmentPaymentObligation.Customer) {
        return 'מועבר למנוי'
      }
      else {
        return 'נשאר בחברה'
      }
    }
  }

  return (
    <div className="dashboard-table-row">
      <div className="dashboard-table-row-data">{convertDateTimeToDate(row.createData)}</div>
      <div className="dashboard-table-row-customer semi">{`${row.subscriberFirstName} ${row.subscriberLastName}`}</div>
      <div className="dashboard-table-row-idNumber">{row.subscriberIdNumber}</div>
      <div className="dashboard-table-row-phone">{row.subscriberPhoneNumber?.replace(/^(.{3})(.*)$/, '$1-$2')}</div>
      <div className="dashboard-table-row-action-type">{OwnershipTransferActionTypeDescription[row.actionType]}</div>
      <div className="dashboard-table-row-performed-by">{RequestExecutedByDescription[row.requestExecutedBy]}</div>
      <div className="dashboard-table-row-equipment">{getEquipmentTitle()}</div>
      <div className="dashboard-table-row-status semi">{getColumnData()}</div>
    </div>
  )
}
const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  validateOwnershipTransferStatus

};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardTableRow);

